import React, { useRef } from 'react';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';

import 'react-datepicker/dist/react-datepicker.css';
import './sass/datePickerStyle.scss';
import CustomDateInput from './components/CustomDateInput';

const CustomDatePicker = ({
  startDate, endDate, setStartDate,
  setEndDate, placeholderText, maxDate,
  minDate, monthsShown, selectsRange
}) => {
  const ref = useRef();
  const onChange = (dates) => {
    if (dates?.length > 1) {
      const [start, end] = dates;
      setStartDate(start);
      setEndDate(end);
    } else {
      setStartDate(dates);
    }
  };

  return (
    <DatePicker
      placeholderText={placeholderText}
      dateFormat="yyyy-MM-dd"
      selected={startDate}
      startDate={startDate}
      selectsRange={selectsRange}
      endDate={endDate}
      onChange={onChange}
      customInput={<CustomDateInput placeholderText={placeholderText} ref={ref} />}
      isClearable
      maxDate={maxDate}
      minDate={minDate}
      monthsShown={monthsShown}
    />
  );
};

CustomDatePicker.propTypes = {
  setStartDate: PropTypes.func,
  setEndDate: PropTypes.func,
  startDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  endDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  maxDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  minDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  placeholderText: PropTypes.string,
  monthsShown: PropTypes.number,
  selectsRange: PropTypes.bool,
};

CustomDatePicker.defaultProps = {
  setStartDate: () => {},
  setEndDate: () => {},
  startDate: null,
  endDate: null,
  maxDate: null,
  minDate: null,
  placeholderText: undefined,
  monthsShown: 1,
  selectsRange: true,
};

export default CustomDatePicker;
